import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NavBarNB from './components/NavBarNB';
import HeroNB from './components/HeroNB';
import FeatureCardsNB from './components/FeatureCardsNB';
import RepairJourneyNB from './components/RepairJourneyNB';
import DashboardPreviewNB from './components/DashboardPreviewNB';
import BeforeAfterNB from './components/BeforeAfterNB';
import PricingNB from './components/PricingNB';
import SocialProofNB from './components/SocialProofNB';
import TrackDemoNB from './components/TrackDemoNB';
import CTABandNB from './components/CTABandNB';
import FooterNB from './components/FooterNB';
import { useAuthStore } from './stores/authStore';
import { useRole } from './hooks/useRole';

export default function App() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const organizationId = useAuthStore(s => s.user?.organizationId);
  const role = useRole();

  useEffect(() => {
    if (isAuthenticated) {
      if (organizationId) {
        const target = role === 'admin' ? `/${lang || 'en'}/admin` : `/${lang || 'en'}/technician`;
        navigate(target, { replace: true });
      } else {
        navigate(`/${lang || 'en'}/setup/role`, { replace: true });
      }
    }
  }, [isAuthenticated, organizationId, role, lang, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-nb-cream">
      <NavBarNB />
      <main className="flex-1">
        <HeroNB />
        <FeatureCardsNB />
        <RepairJourneyNB />
        <DashboardPreviewNB />
        <BeforeAfterNB />
        <PricingNB />
        <SocialProofNB />
        <TrackDemoNB />
        <CTABandNB />
      </main>
      <FooterNB />
    </div>
  );
}